__turbopack_context__.v({
  "account-stats": "profile-module-scss-module__0AcxNW__account-stats",
  "banners-wrapper": "profile-module-scss-module__0AcxNW__banners-wrapper",
  "bottom-banner": "profile-module-scss-module__0AcxNW__bottom-banner",
  "bottom-banner-content": "profile-module-scss-module__0AcxNW__bottom-banner-content",
  "bottom-banner-wrapper": "profile-module-scss-module__0AcxNW__bottom-banner-wrapper",
  "close-button": "profile-module-scss-module__0AcxNW__close-button",
  "greeting": "profile-module-scss-module__0AcxNW__greeting",
  "header": "profile-module-scss-module__0AcxNW__header",
  "header-wrapper": "profile-module-scss-module__0AcxNW__header-wrapper",
  "info-icon": "profile-module-scss-module__0AcxNW__info-icon",
  "is-open": "profile-module-scss-module__0AcxNW__is-open",
  "label": "profile-module-scss-module__0AcxNW__label",
  "lead": "profile-module-scss-module__0AcxNW__lead",
  "learn-more-tooltip": "profile-module-scss-module__0AcxNW__learn-more-tooltip",
  "learn-more-wrapper": "profile-module-scss-module__0AcxNW__learn-more-wrapper",
  "main-wrapper": "profile-module-scss-module__0AcxNW__main-wrapper",
  "maxed": "profile-module-scss-module__0AcxNW__maxed",
  "no-premium-header": "profile-module-scss-module__0AcxNW__no-premium-header",
  "open-button": "profile-module-scss-module__0AcxNW__open-button",
  "pencil-icon": "profile-module-scss-module__0AcxNW__pencil-icon",
  "profile-registered-domain-value": "profile-module-scss-module__0AcxNW__profile-registered-domain-value",
  "profile-wrapper": "profile-module-scss-module__0AcxNW__profile-wrapper",
  "size-information": "profile-module-scss-module__0AcxNW__size-information",
  "stat": "profile-module-scss-module__0AcxNW__stat",
  "stat-wrapper": "profile-module-scss-module__0AcxNW__stat-wrapper",
  "subdomain": "profile-module-scss-module__0AcxNW__subdomain",
  "tooltip": "profile-module-scss-module__0AcxNW__tooltip",
  "upsell-banner": "profile-module-scss-module__0AcxNW__upsell-banner",
  "upsell-banner-content": "profile-module-scss-module__0AcxNW__upsell-banner-content",
  "upsell-banner-description": "profile-module-scss-module__0AcxNW__upsell-banner-description",
  "upsell-banner-header": "profile-module-scss-module__0AcxNW__upsell-banner-header",
  "upsell-banner-image": "profile-module-scss-module__0AcxNW__upsell-banner-image",
  "upsell-banner-wrapper": "profile-module-scss-module__0AcxNW__upsell-banner-wrapper",
  "user-details": "profile-module-scss-module__0AcxNW__user-details",
  "value": "profile-module-scss-module__0AcxNW__value",
});
